import React, { useState, useEffect } from "react";
import AuthUser from '../Auth/AuthUser';
import { useMediaQuery, Grid, Select, FormControl, MenuItem,IconButton,Chip,TextareaAutosize ,FormHelperText, Input, InputLabel, FormLabel, RadioGroup, Radio, TextField, InputAdornment, Tooltip, ClickAwayListener, OutlinedInput, Backdrop, Checkbox, FormControlLabel, Stack, Dialog, DialogContent, DialogActions } from '@mui/material';
import { Typography, Card, CardContent, CardOverflow, Button } from '@mui/joy';
import NotificationsIcon from '@material-ui/icons/Notifications';
import NotificationsOffIcon from '@material-ui/icons/NotificationsOff';
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import SpeakerNotesOffIcon from '@mui/icons-material/SpeakerNotesOff';
import * as Yup from 'yup';
import { Formik, FieldArray } from 'formik';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
// import SnapshotOperationalHours from '../../Components/SnapshotOperationalHours';
import DeleteOutline from '@mui/icons-material/DeleteOutline';
import swal from "sweetalert";
import InputMask from 'react-input-mask';
import { useDispatch } from 'react-redux';
import { postData, postFormData } from '../../redux/apiSlice';
import Freez from '../../Components/Loader/Loader';
import { styled } from '@mui/material/styles';
import SnapshotOperationalHours from "./SnapshotOperationalHours";
import iIcon from '../../assets/images/i_icon.png';
import InfoIcon from '@mui/icons-material/Info';
import Visibility from '@mui/icons-material/Visibility';
import { exampleHTML } from '../../../src/views/Web/CreditSnapshot/CreditTermsAndCondition';
import jsPDF from 'jspdf';
import CloseIcon from "@mui/icons-material/Close";
let blankValueIndexes1 = [];
let blankValueIndexes2 = [];
let operationalhoursvalues = [];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 350,
        },
    },
};

const CustomInputAdornment = styled(InputAdornment)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    '& .MuiIconButton-root': {
        padding: '3px', // Apply reduced padding to all IconButtons
    },
}));

const CompanyDetails = ({ receivedphone, defaultPhoneNumber, receivedemails, defaultEmail, receivedpid, receivedaid, business, creditinfo, pids, aidlist1, firstAid, receivedshift, fetchCreditInfo, defaultOutOfOfficeMsg, terms }) => {
    console.log("company pids",pids);
    const { http, user } = AuthUser();
    const isMobile = useMediaQuery('(max-width:600px)');
    const dispatch = useDispatch();
    const [freez, setFreez] = React.useState(false);
    const [outOfOfficeLabel, setOutOfOfficeLabel] = useState(creditinfo && creditinfo.data && creditinfo.data.enable_chat_support === 1 ? "Out Of Office Message For Chat Support*" : "Out Of Office Message For Chat Support");
    const [signupLinkLabel, setSignupLinkLabel] = useState(creditinfo && creditinfo.data && creditinfo.data.crs_signup_enabled === 1 ? "Add Your Customer Signup Link*" : "Add Your Customer Signup Link");
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [openTooltip, setOpenTooltip] = useState(false);
    const handleTooltipOpen = () => {
        setOpenTooltip(true);
    };

    const handleTooltipClose = () => {
        setOpenTooltip(false);
    };
    console.log("receivedpid1:",receivedpid);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleOpen2 = () => {
        setOpen2(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleClose2 = () => {
        setOpen2(false);
    };

    // tooltip popup end here
    const CustomSelect = styled(Select)(({ theme }) => ({
        '& .MuiInput-underline:before': {
            borderBottom: 'none',
        },
        '& .MuiInput-underline:after': {
            borderBottom: 'none',
        },
    }));

    const [step1Option, setStep1Option] = useState(() => {
        if (creditinfo && creditinfo.data && creditinfo.data.step_1_link) {
            if (creditinfo.data.step_1_link.includes('youtube.com') || creditinfo.data.step_1_link.includes('youtube.com/embed')) {
                return 'youTube';  // or any value representing YouTube
            } else if (creditinfo.data.step_1_link.includes('vimeo.com')) {
                return 'vimeo';  // or any value representing Vimeo
            } else if (creditinfo.data.step_1_link.includes('mp4')) {
                return 'uploadVideo';  // default value if neither
            }
        }
        return '';  // fallback in case creditinfo is not available
    });
    const [step2Option, setStep2Option] = useState(() => {
        if (creditinfo && creditinfo.data && creditinfo.data.step_2_link) {
            if (creditinfo.data.step_2_link.includes('youtube.com') || creditinfo.data.step_2_link.includes('youtube.com/embed')) {
                return 'youTube';  // or any value representing YouTube
            } else if (creditinfo.data.step_2_link.includes('vimeo.com')) {
                return 'vimeo';  // or any value representing Vimeo
            } else if (creditinfo.data.step_2_link.includes('mp4')) {
                return 'uploadVideo';  // default value if neither
            }
        }
        return '';  // fallback in case creditinfo is not available
    });
    const [step3Option, setStep3Option] = useState(() => {
        if (creditinfo && creditinfo.data && creditinfo.data.summary_page_link) {
            if (creditinfo.data.summary_page_link.includes('youtube.com') || creditinfo.data.summary_page_link.includes('youtube.com/embed')) {
                return 'youTube';  // or any value representing YouTube
            } else if (creditinfo.data.summary_page_link.includes('vimeo.com')) {
                return 'vimeo';  // or any value representing Vimeo
            } else if (creditinfo.data.summary_page_link.includes('mp4')) {
                return 'uploadVideo';  // default value if neither
            }
        }
        return '';  // fallback in case creditinfo is not available
    });
    const [values, setValues] = useState({
        step1Link: '',
        step2Link: '',
        step3Link: ''
    });
    const handleClearStep1 = (setFieldValue) => {
        setFieldValue('step1Option', ''); // Reset radio selection
        setFieldValue('step1Link', '');   // Also clear the text field or uploaded file
        setStep1Option('');   
    };

    const handleClearStep2 = (setFieldValue) => {
        setFieldValue('step2Option', ''); // Reset radio selection
        setFieldValue('step2Link', '');   // Also clear the text field or uploaded file
        setStep2Option('');   
    };
    const handleClearStep3 = (setFieldValue) => {
        setFieldValue('step3Option', ''); // Reset radio selection
        setFieldValue('summaryLink', '');   // Also clear the text field or uploaded file
        setStep3Option('');   
    };
    const handleStep1RadioChange = (event, setFieldValue, values) => {
        const selectedOption = event.target.value;
        setStep1Option(selectedOption);

        // Clear the `step1Link` value when switching options
        if (selectedOption !== 'uploadVideo') {
            if (values.step1Link instanceof File) {
                setFieldValue('step1Link', '');  // Clear the input field if it's not a string
            }
            else {
                setFieldValue('step1Link', creditinfo ? creditinfo.data ? creditinfo.data.step_1_link ? creditinfo.data.step_1_link : "" : "" : "");
            }
        }
    };

    const handleStep2RadioChange = (event, setFieldValue, values) => {
        const selectedOption1 = event.target.value;
        setStep2Option(event.target.value);
        if (selectedOption1 !== 'uploadVideo') {
            if (values.step2Link instanceof File) {
                setFieldValue('step2Link', '');  // Clear the input field if switching away from "Upload Video"
            } else {
                setFieldValue('step2Link', creditinfo ? creditinfo.data ? creditinfo.data.step_2_link ? creditinfo.data.step_2_link : "" : "" : "");
            }
        }
    };

    const handleStep3RadioChange = (event, setFieldValue, values) => {
        const selectedOption2 = event.target.value;
        setStep3Option(event.target.value);
        if (selectedOption2 !== 'uploadVideo') {
            if (values.summaryLink instanceof File) {
                setFieldValue('summaryLink', '');  // Clear the input field if switching away from "Upload Video"
            } else {
                setFieldValue('summaryLink', creditinfo ? creditinfo.data ? creditinfo.data.summary_page_link ? creditinfo.data.summary_page_link : "" : "" : "");
            }
        }
    };


    const CustomInputLabel = styled(InputLabel)(({ theme }) => ({
        '&.Mui-focused': {
            color: theme.palette.text.primary,
        },
    }));

    const validateVideoUrl = (url) => {
        // Regex for video file extensions
        const videoFileRegex = /\.(mp4|webm|ogg|avi|mov|mkv)$/i;

        // Regex for video platforms like YouTube and Vimeo
        const videoPlatformRegex = /(youtube\.com|youtu\.be|vimeo\.com)/i;

        // Validate URL as video link
        if (videoFileRegex.test(url) || videoPlatformRegex.test(url)) {
            return true;
        }
        return false;
    };

    const validationSchema = Yup.object().shape({
        PID1: Yup.string()
            .required('Please select PID.'),
        AID: Yup.string()

            .required('Please select AID.'),
       
        outOfOfficeMsg: Yup.string().when("signupEnabled", {
            is: (signupEnabled) => signupEnabled == true,
            then: (schema) => schema
                .required('Out of office chat message is Required')
                .min(2, 'Too Short!'),
        }),

        step1Link: Yup.mixed()
            .test(
                "is-valid-step1Link",
                "Invalid input. Please provide a valid URL or an MP4 file.", // Default error message
                function (value) {
                    if ((value === "" || value === null || value === undefined) && step1Option) {
                        return this.createError({
                          path: this.path,
                          message: "Step 1 Link is required.",
                        });
                    }
                    // YouTube URL validation
                    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=[\w-]+|embed\/[\w-]+|shorts\/[\w-]+)|youtu\.be\/[\w-]+)/;
                    // Vimeo URL validation
                    const vimeoRegex = /^(https?:\/\/)?(www\.)?(vimeo\.com\/(video\/)?\d+|player\.vimeo\.com\/video\/\d+)/;
                    if (typeof value === "string") {
                        if (step1Option === 'youTube') {
                            // Validate YouTube URL using the regex
                            if (youtubeRegex.test(value)) {
                                return true; // Valid YouTube URL
                            } else {
                                return this.createError({
                                    path: this.path,
                                    message: "Step 1 Link must be a valid YouTube URL.",
                                });
                            }
                        }

                        if (step1Option === 'vimeo') {
                            // Validate Vimeo URL using the regex
                            if (vimeoRegex.test(value)) {
                                return true; // Valid Vimeo URL
                            } else {
                                return this.createError({
                                    path: this.path,
                                    message: "Step 1 Link must be a valid Vimeo URL.",
                                });
                            }
                        }
                    }
                    // Check if value is a File object and validate file type and size
                    if (value instanceof File) {
                        if (value.type !== "video/mp4") {
                            return this.createError({
                                path: this.path,
                                message: "Step 1 File must be an MP4 video file.",
                            });
                        }
                        const maxSizeInBytes = 10 * 1024 * 1024; // 10 MB
                        if (value.size > maxSizeInBytes) {
                            return this.createError({
                                path: this.path,
                                message: "Step 1 File size must not exceed 10MB.",
                            });
                        }
                        return true; // Valid MP4 file within size limit
                    }
                    return true;
                }
            ),
        step2Link: Yup.mixed()
            .test(
                "is-valid-step2Link",
                "Invalid input. Please provide a valid URL or an MP4 file.", // Default error message
                function (value) {
                    // Allow empty values (optional field)
                    if ((value === "" || value === null || value === undefined) && step2Option) {
                        return this.createError({
                          path: this.path,
                          message: "Step 2 Link is required.",
                        });
                    }

                    // YouTube URL validation
                    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=[\w-]+|embed\/[\w-]+|shorts\/[\w-]+)|youtu\.be\/[\w-]+)/;
                    // Vimeo URL validation
                    const vimeoRegex = /^(https?:\/\/)?(www\.)?(vimeo\.com\/(video\/)?\d+|player\.vimeo\.com\/video\/\d+)/;

                    if (typeof value === "string") {
                        if (step2Option === 'youTube') {
                            // Validate YouTube URL using the regex
                            if (youtubeRegex.test(value)) {
                                return true; // Valid YouTube URL
                            } else {
                                return this.createError({
                                    path: this.path,
                                    message: "Step 2 Link must be a valid YouTube URL.",
                                });
                            }
                        }

                        if (step2Option === 'vimeo') {
                            // Validate Vimeo URL using the regex
                            if (vimeoRegex.test(value)) {
                                return true; // Valid Vimeo URL
                            } else {
                                return this.createError({
                                    path: this.path,
                                    message: "Step 2 Link must be a valid Vimeo URL.",
                                });
                            }
                        }
                    }

                    // Check if value is a File object and validate file type and size
                    if (value instanceof File) {
                        if (value.type !== "video/mp4") {
                            return this.createError({
                                path: this.path,
                                message: "Step 2 File must be an MP4 video file.",
                            });
                        }
                        const maxSizeInBytes = 10 * 1024 * 1024; // 10 MB
                        if (value.size > maxSizeInBytes) {
                            return this.createError({
                                path: this.path,
                                message: "Step 2 File size must not exceed 10MB.",
                            });
                        }
                        return true; // Valid MP4 file within size limit
                    }
                    return true;
                }
            ),
        summaryLink: Yup.mixed()
            .test(
                "is-valid-summaryLink",
                "Invalid input. Please provide a valid URL or an MP4 file.", // Default error message
                function (value) {
                    // Allow empty values (optional field)
                    if ((value === "" || value === null || value === undefined) && step3Option) {
                        return this.createError({
                          path: this.path,
                          message: "Summary Link is required.",
                        });
                    }

                    // YouTube URL validation
                    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=[\w-]+|embed\/[\w-]+|shorts\/[\w-]+)|youtu\.be\/[\w-]+)/;
                    // Vimeo URL validation
                    const vimeoRegex = /^(https?:\/\/)?(www\.)?(vimeo\.com\/(video\/)?\d+|player\.vimeo\.com\/video\/\d+)/;

                    if (typeof value === "string") {
                        if (step3Option === 'youTube') {
                            // Validate YouTube URL using the regex
                            if (youtubeRegex.test(value)) {
                                return true; // Valid YouTube URL
                            } else {
                                return this.createError({
                                    path: this.path,
                                    message: "Credit Report Summary Link must be a valid YouTube URL.",
                                });
                            }
                        }

                        if (step3Option === 'vimeo') {
                            // Validate Vimeo URL using the regex
                            if (vimeoRegex.test(value)) {
                                return true; // Valid Vimeo URL
                            } else {
                                return this.createError({
                                    path: this.path,
                                    message: "Credit Report Summary Link must be a valid Vimeo URL.",
                                });
                            }
                        }
                    }

                    // Check if value is a File object and validate file type and size
                    if (value instanceof File) {
                        if (value.type !== "video/mp4") {
                            return this.createError({
                                path: this.path,
                                message: "Credit Report Summary File must be an MP4 video file.",
                            });
                        }
                        const maxSizeInBytes = 10 * 1024 * 1024; // 10 MB
                        if (value.size > maxSizeInBytes) {
                            return this.createError({
                                path: this.path,
                                message: "Credit Report Summary File size must not exceed 10MB.",
                            });
                        }
                        return true; // Valid MP4 file within size limit
                    }
                    return true;
                }
            ),
        creditSnapshotLink: Yup.string().when("signupEnabled", {
                            is: (signupEnabled) => signupEnabled == true,
                            then: (schema) => schema
                                .required('Credit Repair Signup Link is Required')
                                .url('Please enter a valid URL.'),
                            }),
    });


    const CreateSnapInfo = async (values) => {
        setFreez(true);
        const formData = new FormData();
        formData.append('pid', values.PID1);
        formData.append('aidid', values.AID);
        formData.append('outOfOfficeMsg', values.outOfOfficeMsg);
        formData.append('signupEnabled', values.signupEnabled);
        formData.append('chatEnabled', values.chatEnabled);
        formData.append('emailEnabled', values.emailEnabled);
        formData.append('step1Link', values.step1Link); // Append the file
        formData.append('step2Link', values.step2Link); // Append the file
        formData.append('summaryLink', values.summaryLink); // Append the file
        formData.append('creditSnapshotLink', values.creditSnapshotLink);
        const apiUrl = '/updateSnapshotDetails';

        const res = await dispatch(postFormData({ apiUrl, formData })).unwrap();
        if (res) {
            if (res.success === true) {
                fetchCreditInfo();
                swal({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    button: "Ok",
                })
            } else {
                swal({
                    title: "Alert",
                    text: "Something went wrong please try again",
                    icon: "error",
                    button: "Ok",
                })
            }
        }
        setFreez(false);
    }

    

const handleDownloadPDF = async (data) => {
    // console.log(data);
    const firstName = data ? data.reference_affiliates.first_name ? data.reference_affiliates.first_name : "" : "";
    const lastName = data ? data.reference_affiliates.last_name ? data.reference_affiliates.last_name : "" : "";
    const fullName = firstName + " " + lastName;
    const companyName = data ? data.company.company_name ? data.company.company_name : "" : "";
    const title = data ? data.company.title ? data.company.title : "" : "";
    const updateDate = data ? data.updated_at ? data.updated_at : "" : "";
    const sign = data ? data.sign_image : "";
    const executiveSign = data ? data.executive : "";
    const dateFormat = new Date(updateDate);
    const options = { timeZone: 'America/Los_Angeles', month: '2-digit', day: '2-digit', year: 'numeric' };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const [
        { value: month }, ,
        { value: day }, ,
        { value: year }
    ] = formatter.formatToParts(dateFormat);

    const formattedDate = `${month}/${day}/${year}`;
    const advertiser = {
        adverstise: companyName,
        signature: fullName,
        printName: fullName,
        title: title,
        date: formattedDate
    };

    const sample = ` <div style="font-size:16px;padding: 5px 0px;width:750px;text-align:justify;"> 
        <p>
        <span style="font-size: 18px; text-align: center;"><b>Standard Terms and Conditions for Lead Generation Service: Lead Generation (Last revised Jan 12 2025)</b></span>
        </p>
        <br><br>
            ${exampleHTML(advertiser)}
            <br>
            <div class="forMD-12" style="display: flex; flex-wrap: wrap; margin-top: 2px;">
            <div class="forMD-6" style="flex: 1; min-width: 65%;">
                <p style="margin: 0; padding: 2px;"><strong>Advertiser: ${companyName}</strong></p>
                <p style="margin: 0; padding: 2px; display: flex; align-items: center;">
                    <strong>Signature:</strong>
                    ${sign ?
            `<img src="${sign}" alt="Signature" style="width: 40%; height: auto;" />`
            :
            `<span style="margin-left: 10px;">${fullName}</span>`
        }
                </p>
                <p style="margin: 0; padding: 2px;"><strong>Print Name: ${fullName}</strong></p>
                <p style="margin: 0; padding: 2px;"><strong>Title: ${title}</strong></p>
                <p style="margin: 0; padding: 2px;"><strong>Date: ${formattedDate}</strong></p>
            </div>
            <div class="forMD-6" style="flex: 1; min-width: 35%;">
                <p style="margin: 0; padding: 2px;"><strong>Vendor: MyFreeScoreNow Inc.</strong></p>
                <p style="margin: 0; padding: 2px; display: flex; align-items: center;">
                    <strong>Signature:</strong>
                    <img src="${executiveSign}" alt="Executive Signature" style="width: 45%; height: auto; margin-left: 10px;" />
                </p>
                <p style="margin: 0; padding: 2px;"><strong>Print Name: Bruce J. Cornelius</strong></p>
                <p style="margin: 0; padding: 2px;"><strong>Title: President</strong></p>
                <p style="margin: 0; padding: 2px;"><strong>Date: ${formattedDate}</strong></p>
            </div>
          </div>
          
        </div>`
    var pdf = new jsPDF("p", "px", "a4");
    const paddingTop = 20;
    const paddingBottom = 30;
    pdf.html(sample, {
        margin: [0, 10, 30, 10],
        callback: function (pdf) {
            const totalPages = pdf.internal.getNumberOfPages();
            const totalPadding = paddingTop + paddingBottom;
            for (let i = 0; i < totalPages; i++) {
                pdf.setPage(i + 1);

                pdf.text(
                    `Page ${i + 1} of ${totalPages}`,
                    pdf.internal.pageSize.width / 2,
                    pdf.internal.pageSize.height - 10,
                    { align: 'center', fontSize: '12px' }
                );
                pdf.internal.pageSize.height += totalPadding; // Adjust the page height
            }
            pdf.save('Agreement_Copy.pdf');
        },
        x: 30,
        y: 30,
        autoPaging: 'text',
        html2canvas: { scale: 0.50 },
        width: pdf.internal.pageSize.getWidth() - 20,
    });
};

return (
    <>
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={freez}
            >
                <Freez />
            </Backdrop>
        </div>
        <Card sx={{boxShadow:"none"}}>
            {/* formik start */}
            {/* <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "space-between" }} >
                <Grid item lg={7} md={7} sm={12} xs={12} sx={{ textAlign: "left", marginTop: isMobile ? 2 : 0 }}>
                    <Grid container item lg={12} md={12} sm={12} xs={12} >
                        <Grid container item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "left" }}>
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ textAlign: "left" }}>
                                <Card variant="outlined" sx={{ width: "98%", minHeight: isMobile ? "150px" : "150px", maxHeight: isMobile ? "150px" : "150px", padding: 0 }}>
                                    <a onClick={handleOpen2} href="#" style={{ textDecoration: "none" }}><Typography sx={{ textAlign: "center" }} level="h6" color="primary" >Consumer Experience</Typography></a>
                                    <div onClick={handleOpen2} style={{ cursor: "pointer", marginTop: "10px", marginRight: "10px", marginLeft: "10px" }}>
                                        <iframe
                                            width="100%"
                                            height={isMobile ? "80px" : "100px"}
                                            src="https://www.youtube.com/embed/5SiyOJLt1y0?si=1fQs16b1uKqrHynp"
                                            title="Video Player"
                                            // frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </Card>
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ textAlign: "right" }}>
                                <Card variant="outlined" sx={{ width: "98%", minHeight: isMobile ? "150px" : "150px", maxHeight: isMobile ? "150px" : "150px", padding: 0 }}>
                                    <a onClick={handleOpen} href="#" style={{ textDecoration: "none" }}><Typography sx={{ textAlign: "center" }} level="h6" color="primary" >How To Set Up Credit Snapshot</Typography></a>
                                    <div onClick={handleOpen} style={{ cursor: "pointer", marginTop: "10px", marginRight: "10px", marginLeft: "10px" }}>
                                        <iframe
                                            width="100%"
                                            height={isMobile ? "80px" : "100px"}
                                            src="https://www.youtube.com/embed/QOyOfg9D288?si=-N4y8jsigCi91MFc"
                                            title="Video Player"
                                            // frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </Card>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item lg={5} md={5} sm={12} xs={12} sx={{ textAlign: "right" }}>
                    <Grid container item lg={12} md={12} sm={12} xs={12}>
                        <Grid item lg={12} md={12} sm={6} xs={6} sx={{ marginTop: isMobile ? 0 : 2 }}>
                            {user.roles_id === 3 ? (
                                <Button
                                    color="primary"
                                    sx={{ fontWeight: "bold" }}
                                    onClick={() => handleDownloadPDF(terms)}
                                >
                                    DOWNLOAD AGREEMENT COPY
                                </Button>
                            ) : null}
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> */}
           
            <Formik
                initialValues={{
                    PID1: receivedpid ? receivedpid : "",
                    AID: receivedaid ? receivedaid : firstAid,
                    outOfOfficeMsg: creditinfo ? creditinfo.data ? creditinfo.data.out_of_office_msg ? creditinfo.data.out_of_office_msg : defaultOutOfOfficeMsg : defaultOutOfOfficeMsg : defaultOutOfOfficeMsg,
                    step1Link: creditinfo ? creditinfo.data ? creditinfo.data.step_1_link ? creditinfo.data.step_1_link : "" : "" : "",
                    step2Link: creditinfo ? creditinfo.data ? creditinfo.data.step_2_link ? creditinfo.data.step_2_link : "" : "" : "",
                    summaryLink: creditinfo ? creditinfo.data ? creditinfo.data.summary_page_link ? creditinfo.data.summary_page_link : "" : "" : "",
                    signupEnabled: creditinfo ? creditinfo.data ? creditinfo.data.crs_signup_enabled === 1 ? true : false : false : true,
                    chatEnabled: creditinfo ? creditinfo.data ? creditinfo.data.enable_chat_support === 1 ? true : false : false : true,
                    emailEnabled: creditinfo ? creditinfo.data ? creditinfo.data.enable_email_support === 1 ? true : false : false : true,
                    creditSnapshotLink: creditinfo ? creditinfo.data ? creditinfo.data.credit_snapshot_link ? creditinfo.data.credit_snapshot_link : "" : "" : "",
                }}

                validationSchema={validationSchema}
                context={{ step1Option }}
                onSubmit={(values, errors) => {
                    CreateSnapInfo(values);
                }}
            >
                {({ values, errors, touched, handleChange, handleBlur, setFieldTouched, handleSubmit, setFieldValue, setFieldError }) => (
                    <div>
                      
                            <Grid container item lg={12} md={12} sm={12} xs={12}>
                                <Typography level="h4"  sx={{ color:"black", fontWeight : "600" }}>Upgrade Configuration</Typography>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} mt={1}>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <FormControl size="small" fullWidth margin="dense" error={touched.PID1 && Boolean(errors.PID1)}>
                                        <CustomInputLabel id="demo-simple-select-label">Select Plan To Upgrade From Free To Paid Membership*</CustomInputLabel>
                                        <CustomSelect
                                            labelId="demo-simple-select-label"
                                            id="PID1"
                                            name="PID1"
                                            value={values.PID1}
                                            label="Select Plan To Upgrade From Free To Paid Membership"
                                            onChange={handleChange}
                                            onBlur={handleChange}
                                            style={{ width: '100%' }}
                                            className="textWrap"
                                            MenuProps={MenuProps}
                                        >
                                            {pids.map((pid) => (
                                                <MenuItem key={pid} value={pid}>
                                                    <Chip label={pid} style={{ margin: 2 }} size="small" />
                                                </MenuItem>
                                            ))}
                                        </CustomSelect>
                                        {touched.PID1 && errors.PID1 ? <div className='error'>{errors.PID1}</div> : null}
                                    </FormControl>
                                </Grid>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                {Array.isArray(aidlist1) && aidlist1.length > 1 ? (
                                    <FormControl fullWidth size='small'margin="dense"  error={touched.AID && Boolean(errors.AID)}>
                                        <CustomInputLabel id="demo-multiple-name-label">AID List*</CustomInputLabel>
                                        <CustomSelect
                                            labelId="demo-multiple-name-label"
                                            name='AID'
                                            id='AID'
                                            input={<OutlinedInput label="AID List" />}
                                            onChange={handleChange}
                                            onBlur={handleChange}
                                            style={{ width: '100%' }}
                                            MenuProps={MenuProps}
                                            value={values.AID}
                                        >

                                            {aidlist1.map((aid) => (
                                                <MenuItem key={aid.id} value={aid.id}>
                                                    <Chip label={aid.aid} style={{ margin: 2 }} size="small" />
                                                </MenuItem>
                                            ))}

                                        </CustomSelect>
                                        {touched.AID && errors.AID ? <div className='error'>{errors.AID}</div> : null}
                                    </FormControl>
                                        ) : (
                                        ""
                                    )}
                                </Grid>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} mt={1}>
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <FormControlLabel control={<Checkbox checked={values.signupEnabled} />}
                                        label={
                                            <span style={{ fontWeight: "bold" }}>
                                                Add Your Auto Customer Signup Link For Your CRM
                                            </span>
                                        }
                                        onChange={(e) => {
                                            // showOrHideChatInputs(!values.signupEnabled)
                                            setFieldValue('signupEnabled', !values.signupEnabled, true)
                                            setSignupLinkLabel("Customer Signup Link*");
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid>
                            {
                            values.signupEnabled ?
                                <Grid item lg={6} md={6} sm={12} xs={12}>
                                    <TextField
                                        label={signupLinkLabel}
                                        variant="outlined"
                                        id="creditSnapshotLink"
                                        name="creditSnapshotLink"
                                        size="small"
                                        fullWidth
                                        margin="dense"
                                        value={values.creditSnapshotLink}
                                        onChange={handleChange}
                                        onBlur={handleChange}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <ClickAwayListener onClickAway={handleTooltipClose}>
                                                        <div>
                                                            <Tooltip
                                                                PopperProps={{
                                                                    disablePortal: true, // Ensures the tooltip stays within bounds
                                                                }}
                                                                onClose={handleTooltipClose}
                                                                open={openTooltip}
                                                                disableFocusListener
                                                                disableHoverListener
                                                                disableTouchListener
                                                                title={
                                                                    <div >
                                                                        <p sx={{ fontSize: "100px" }}>
                                                                            Enter The Link Below <br />
                                                                            Where Your Clients Can <br />
                                                                            Automatically Signup <br />
                                                                            For Your Services.
                                                                        </p>
                                                                    </div>
                                                                }
                                                                placement="top-start"
                                                                interactive
                                                            >
                                                                <IconButton
                                                                    aria-label="toggle tooltip"
                                                                    edge="end"
                                                                    onClick={handleTooltipOpen}
                                                                >
                                                                    <img src={iIcon} alt="info" />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </div>
                                                    </ClickAwayListener>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    {touched.creditSnapshotLink && errors.creditSnapshotLink ? <div className='error'>{errors.creditSnapshotLink}</div> : null}

                                </Grid>
                                : <Grid item lg={6} md={6} sm={6} xs={6}>
                                </Grid>}
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} mt={1} >
                                {/* <Grid item lg={6} md={6} sm={6} xs={6}> */}
                                    {/* <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2}> */}
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <FormControlLabel control={<Checkbox checked={values.chatEnabled} />}
                                                label={
                                                    <span style={{ fontWeight: "bold" }}>Enable Chat Support</span>
                                                } onChange={(e) => {
                                                    // showOrHideChatInputs(!values.signupEnabled)
                                                    setFieldValue('chatEnabled', !values.chatEnabled, true)
                                                    setOutOfOfficeLabel("Out Of Office Message For Chat Support*");
                                                }} />

                                        </Grid>
                                        <Grid item lg={6} md={6} sm={6} xs={6}>
                                            <FormControlLabel control={<Checkbox checked={values.emailEnabled} />}
                                                label={
                                                    <span style={{ fontWeight: "bold" }}>Enable Email Support</span>
                                                } onChange={(e) => {
                                                    // showOrHideChatInputs(!values.signupEnabled)
                                                    setFieldValue('emailEnabled', !values.emailEnabled, true)
                                                }} />
                                        </Grid>
                                        
                                    {/* </Grid> */}
                                {/* </Grid> */}
                            </Grid>
                            <>
                                <Grid container item lg={12} md={12} sm={12} xs={12}>
                                    {values.chatEnabled ?
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <FormControl fullWidth sx={{ marginTop: '8px' }}>
                                            <TextareaAutosize
                                                label={outOfOfficeLabel}
                                                variant="outlined"
                                                id="outOfOfficeMsg"
                                                name="outOfOfficeMsg"
                                                fullWidth
                                                color="neutral"
                                                value={values.outOfOfficeMsg}
                                                onChange={handleChange}
                                                onBlur={handleChange}
                                                minRows={3}
                                                style={{
                                                    width: "100%", border: '1px solid #c4c4c4',
                                                    borderRadius: '4px', padding: '4.5px 14px',
                                                    fontSize:"15px"
                                                }}
                                            />
                                            {touched.outOfOfficeMsg && errors.outOfOfficeMsg ? <div className='error'>{errors.outOfOfficeMsg}</div> : null}
                                            </FormControl>
                                        </Grid>
                                        : ""}
                                </Grid>

                            </>



                          
                            <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                                <Typography level="body1" sx={{ fontWeight: "bold" }}>Add Your Company Videos For Each Enrollment Step (Optional)</Typography>
                            </Grid>
                            <Grid container item lg={12} md={12} sm={12} xs={12} spacing={2} mt={1}>
                                <Grid item lg={4} md={4} sm={12} xs={12} sx={{ display: "flex", flexGrow: 1 }}>
                                    <Card variant="outlined" sx={{ border: "1px solid black", display: "flex", flexGrow: 1 }}>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Grid container item lg={12} md={12} xs={12} sm={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                                                <Grid item lg={3} md={3} xs={3} sm={3}>
                                                    <b>Step 1</b> &nbsp;
                                                         <a style={{color: step1Option ? "red" : "gray",
                                                                    pointerEvents: step1Option ? "auto" : "none",
                                                                    cursor: step1Option ? "pointer" : "not-allowed",
                                                                    textDecoration: "underline" }}  
                                                                    onClick={() => step1Option &&  handleClearStep1(setFieldValue)}>
                                                        Clear
                                                        </a>
                                                </Grid>
                                                <Grid item lg={9} md={9} xs={9} sm={9} sx={{ textAlign: "right" }}>
                                                    {step1Option === 'uploadVideo' ?
                                                        <Typography sx={{ color: "red", fontSize: "12px" }}>(Note: Video Size Should Not Exceed 10Mb)</Typography>
                                                        : ""}
                                                </Grid>
                                            </Grid>
                                            <FormControl>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    value={step1Option}
                                                    onChange={(event) => handleStep1RadioChange(event, setFieldValue, values)}
                                                >
                                                    <Stack direction="row" >
                                                        <FormControlLabel value="youTube" control={<Radio />} label={<img
                                                            src={require('../../assets/images/youtubeSnap.png')} // Replace with male icon URL
                                                            alt="Youtube"

                                                            style={{ marginRight: 8, width: "35px" }}
                                                        />} />
                                                        <FormControlLabel value="vimeo" control={<Radio />} label={<img
                                                            src={require('../../assets/images/vimeoLogo.png')} // Replace with male icon URL
                                                            alt="Male"
                                                            style={{ marginRight: 8, width: "55px" }}
                                                        />} />
                                                        <FormControlLabel value="uploadVideo" control={<Radio />} label="Upload Video" />
                                                    </Stack>
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            {step1Option === 'youTube' && (
                                                <>
                                                    <TextField
                                                        label="YoutTube Video Url"
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="dense"
                                                        size="small"
                                                        id="step1Link"
                                                        name="step1Link"
                                                        value={step1Option === 'youTube' ? values.step1Link ? values.step1Link.includes('youtube.com') || values.step1Link.includes('youtube.com/embed') || values.step1Link.includes('youtu.be') ? values.step1Link : '' : '' : ''}
                                                        onChange={handleChange}
                                                        onBlur={handleChange}
                                                    />
                                                    {touched.step1Link && errors.step1Link ? <div className='error'>{errors.step1Link}</div> : null}
                                                </>
                                            )}
                                            {step1Option === 'vimeo' && (
                                                <>
                                                    <TextField
                                                        label="Vimeo Video URL"
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="dense"
                                                        size="small"
                                                        id="step1Link"
                                                        name="step1Link"
                                                        value={step1Option === 'vimeo' ? values.step1Link ? values.step1Link.includes('vimeo') ? values.step1Link : '' : '' : ''}
                                                        onChange={handleChange}
                                                        onBlur={handleChange}
                                                    />
                                                    {touched.step1Link && errors.step1Link ? <div className='error'>{errors.step1Link}</div> : null}
                                                </>
                                            )}
                                            {step1Option === 'uploadVideo' && (
                                                <>
                                                    <FormControl variant="outlined" fullWidth margin="dense" size="small">
                                                        <InputLabel htmlFor="uploadedLogoStep1">Upload Your Video</InputLabel>
                                                        <OutlinedInput
                                                            id="uploadedLogo"
                                                            type="text" // Show the file name instead of the file picker
                                                            value={typeof values.step1Link === "string" && values.step1Link.includes('mp4')
                                                                ? values.step1Link.split('/').pop().split('_').slice(1).join('_')
                                                                : values.step1Link?.name || ""} // Show the file name in the input field
                                                            onBlur={handleBlur}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <Tooltip
                                                                        title={"Upload Video"}
                                                                    >
                                                                        <IconButton
                                                                            edge="end"
                                                                            onClick={() => document.getElementById("hiddenFileInputStep1").click()}
                                                                        >
                                                                            <img
                                                                                src={require("../../assets/images/uploadFile.png")}
                                                                                style={{ height: "25px" }}
                                                                                alt="Upload"
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </InputAdornment>
                                                            }
                                                            label="Upload Your Video"
                                                        />
                                                        <input
                                                            id="hiddenFileInputStep1"
                                                            type="file"
                                                            name="uploaded"
                                                            style={{ display: "none" }} // Hidden input
                                                            accept="video/*"
                                                            onChange={(event) => {
                                                                const file = event.target.files[0];
                                                                if (file) {
                                                                    setFieldValue("step1Link", file); // Set the file value
                                                                }
                                                            }}
                                                        />
                                                    </FormControl>
                                                    {touched.step1Link && errors.step1Link ? (
                                                        <div className="error">{errors.step1Link}</div>
                                                    ) : null}
                                                </>
                                            )}
                                        </Grid>
                                    </Card>

                                </Grid>
                                <Grid item lg={4} md={4} sm={12} xs={12} sx={{ display: "flex", flexGrow: 1 }}>
                                    <Card variant="outlined" sx={{ border: "1px solid black", display: "flex", flexGrow: 1 }}>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Grid container item lg={12} md={12} xs={12} sm={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                                                <Grid item lg={3} md={3} xs={3} sm={3}>
                                                    <b>Step 2</b>&nbsp;
                                                         <a style={{color: step2Option ? "red" : "gray",
                                                                    pointerEvents: step2Option ? "auto" : "none",
                                                                    cursor: step2Option ? "pointer" : "not-allowed",
                                                                    textDecoration: "underline" }}  
                                                                    onClick={() => step2Option &&  handleClearStep2(setFieldValue)}>
                                                        Clear
                                                        </a>
                                                </Grid>
                                                <Grid item lg={9} md={9} xs={9} sm={9} sx={{ textAlign: "right" }}>
                                                    {step2Option === 'uploadVideo' ?
                                                        <Typography sx={{ color: "red", fontSize: "12px" }}>(Note: Video Size Should Not Exceed 10Mb)</Typography>
                                                        : ""}
                                                </Grid>
                                            </Grid>
                                            <FormControl>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    value={step2Option}
                                                    onChange={(event) => handleStep2RadioChange(event, setFieldValue, values)}
                                                >
                                                    <Stack direction="row" >
                                                        <FormControlLabel value="youTube" control={<Radio />} label={<img
                                                            src={require('../../assets/images/youtubeSnap.png')} // Replace with male icon URL
                                                            alt="Youtube"

                                                            style={{ marginRight: 8, width: "35px" }}
                                                        />} />
                                                        <FormControlLabel value="vimeo" control={<Radio />} label={<img
                                                            src={require('../../assets/images/vimeoLogo.png')} // Replace with male icon URL
                                                            alt="Male"
                                                            style={{ marginRight: 8, width: "55px" }}
                                                        />} />
                                                        <FormControlLabel value="uploadVideo" control={<Radio />} label="Upload Video" />
                                                    </Stack>
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            {step2Option === 'youTube' && (
                                                <>
                                                    <TextField
                                                        label="YoutTube Video Url"
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="dense"
                                                        size="small"
                                                        id="step2Link"
                                                        name="step2Link"
                                                        value={step2Option === 'youTube' ? values.step2Link ? values.step2Link.includes('youtube.com') || values.step2Link.includes('youtube.com/embed') || values.step2Link.includes('youtu.be') ? values.step2Link : '' : '' : ''}
                                                        onChange={handleChange}
                                                        onBlur={handleChange}
                                                    />
                                                    {touched.step2Link && errors.step2Link ? <div className='error'>{errors.step2Link}</div> : null}
                                                </>
                                            )}
                                            {step2Option === 'vimeo' && (
                                                <>
                                                    <TextField
                                                        label="Vimeo Video URL"
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="dense"
                                                        size="small"
                                                        id="step2Link"
                                                        name="step2Link"
                                                        value={step2Option === 'vimeo' ? values.step2Link ? values.step2Link.includes('vimeo') ? values.step2Link : '' : '' : ''}
                                                        onChange={handleChange}
                                                        onBlur={handleChange}
                                                    />
                                                    {touched.step2Link && errors.step2Link ? <div className='error'>{errors.step2Link}</div> : null}
                                                </>
                                            )}
                                            {step2Option === 'uploadVideo' && (
                                                <>
                                                    <FormControl variant="outlined" fullWidth margin="dense" size="small">
                                                        <InputLabel htmlFor="uploadedLogoStep2">Upload Your Video</InputLabel>
                                                        <OutlinedInput
                                                            id="uploadedLogo"
                                                            name="uploaded"
                                                            type="text" // Show the file name instead of the file picker
                                                            value={typeof values.step2Link === "string" && values.step2Link.includes('mp4')
                                                                ? values.step2Link.split('/').pop().split('_').slice(1).join('_')
                                                                : values.step2Link?.name || ""} // Show the file name in the input field
                                                            onBlur={handleBlur}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <Tooltip
                                                                        title={"Upload Video"}
                                                                    >
                                                                        <IconButton
                                                                            edge="end"
                                                                            onClick={() => document.getElementById("hiddenFileInputStep2").click()}
                                                                        >
                                                                            <img
                                                                                src={require("../../assets/images/uploadFile.png")}
                                                                                style={{ height: "25px" }}
                                                                                alt="Upload"
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </InputAdornment>
                                                            }
                                                            label="Upload Your Video"
                                                        />
                                                        <input
                                                            id="hiddenFileInputStep2"
                                                            type="file"
                                                            name="uploaded"
                                                            style={{ display: "none" }} // Hidden input
                                                            accept="video/*"
                                                            onChange={(event) => {
                                                                const file = event.target.files[0];
                                                                if (file) {
                                                                    setFieldValue('step2Link', file); // Set the file value
                                                                }
                                                            }}
                                                        />
                                                    </FormControl>
                                                    {touched.step2Link && errors.step2Link ? (
                                                        <div className="error">{errors.step2Link}</div>
                                                    ) : null}
                                                </>
                                            )}
                                        </Grid>
                                    </Card>
                                </Grid>
                                <Grid item lg={4} md={4} sm={12} xs={12} sx={{ display: "flex", flexGrow: 1 }} >
                                    <Card variant="outlined" sx={{ border: "1px solid black", display: "flex", flexGrow: 1 }}>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Grid container item lg={12} md={12} xs={12} sm={12} sx={{ display: "flex", justifyContent: "space-between" }}>
                                                <Grid item lg={8} md={8} xs={8} sm={8}>
                                                    <b>Credit Report Summary Page</b> &nbsp;
                                                         <a style={{color: step3Option ? "red" : "gray",
                                                                    pointerEvents: step3Option ? "auto" : "none",
                                                                    cursor: step3Option ? "pointer" : "not-allowed",
                                                                    textDecoration: "underline" }}  
                                                                    onClick={() => step3Option &&  handleClearStep3(setFieldValue)}>
                                                        Clear
                                                        </a>
                                                </Grid>
                                                <Grid item lg={4} md={4} xs={4} sm={4} sx={{ textAlign: "right" }}>
                                                    {step3Option === 'uploadVideo' ?
                                                        <Typography sx={{ color: "red", fontSize: "12px" }}>(Note: Video Size Should Not Exceed 10Mb)</Typography>
                                                        : ""}
                                                </Grid>
                                            </Grid>
                                            <FormControl>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                                    name="row-radio-buttons-group"
                                                    value={step3Option}
                                                    onChange={(event) => handleStep3RadioChange(event, setFieldValue, values)}
                                                >
                                                    <Stack direction="row">
                                                        <FormControlLabel value="youTube" control={<Radio />} label={<img
                                                            src={require('../../assets/images/youtubeSnap.png')} // Replace with male icon URL
                                                            alt="Youtube"

                                                            style={{ marginRight: 8, width: "35px" }}
                                                        />} />
                                                        <FormControlLabel value="vimeo" control={<Radio />} label={<img
                                                            src={require('../../assets/images/vimeoLogo.png')} // Replace with male icon URL
                                                            alt="Male"
                                                            style={{ marginRight: 8, width: "55px" }}
                                                        />} />
                                                        <FormControlLabel value="uploadVideo" control={<Radio />} label="Upload Video" />
                                                    </Stack>
                                                </RadioGroup>
                                            </FormControl>
                                        </Grid>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            {step3Option === 'youTube' && (
                                                <>
                                                    <TextField
                                                        label="YoutTube Video Url"
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="dense"
                                                        size="small"
                                                        id="summaryLink"
                                                        name="summaryLink"
                                                        value={step3Option === 'youTube' ? values.summaryLink ? values.summaryLink.includes('youtube.com') || values.summaryLink.includes('youtube.com/embed') || values.summaryLink.includes('youtu.be') ? values.summaryLink : '' : '' : ''}
                                                        onChange={handleChange}
                                                        onBlur={handleChange}
                                                    />
                                                    {touched.summaryLink && errors.summaryLink ? <div className='error'>{errors.summaryLink}</div> : null}
                                                </>
                                            )}
                                            {step3Option === 'vimeo' && (
                                                <>
                                                    <TextField
                                                        label="Vimeo Video URL"
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="dense"
                                                        size="small"
                                                        id="summaryLink"
                                                        name="summaryLink"
                                                        value={step3Option === 'vimeo' ? values.summaryLink ? values.summaryLink.includes('vimeo') ? values.summaryLink : '' : '' : ''}
                                                        onChange={handleChange}
                                                        onBlur={handleChange}
                                                    />
                                                    {touched.summaryLink && errors.summaryLink ? <div className='error'>{errors.summaryLink}</div> : null}
                                                </>
                                            )}
                                            {step3Option === 'uploadVideo' && (
                                                <>
                                                    <FormControl variant="outlined" fullWidth margin="dense" size="small">
                                                        <InputLabel htmlFor="uploadedLogoStep3">Upload Your Video</InputLabel>
                                                        <OutlinedInput
                                                            id="uploadedLogo"
                                                            name="uploaded"
                                                            type="text" // Show the file name instead of the file picker
                                                            value={typeof values.summaryLink === "string" && values.summaryLink.includes('mp4')
                                                                ? values.summaryLink.split('/').pop().split('_').slice(1).join('_')
                                                                : values.summaryLink?.name || ""} // Show the file name in the input field
                                                            onBlur={handleBlur}
                                                            endAdornment={
                                                                <InputAdornment position="end">
                                                                    <Tooltip
                                                                        title={"Upload Video"}
                                                                    >
                                                                        <IconButton
                                                                            edge="end"
                                                                            onClick={() => document.getElementById("hiddenFileInput3").click()}
                                                                        >
                                                                            <img
                                                                                src={require("../../assets/images/uploadFile.png")}
                                                                                style={{ height: "25px" }}
                                                                                alt="Upload"
                                                                            />
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                </InputAdornment>
                                                            }
                                                            label="Upload Your Video"
                                                        />
                                                        <input
                                                            id="hiddenFileInput3"
                                                            type="file"
                                                            name="uploaded"
                                                            style={{ display: "none" }} // Hidden input
                                                            accept="video/*"
                                                            onChange={(event) => {
                                                                const file = event.target.files[0];
                                                                if (file) {
                                                                    setFieldValue('summaryLink', file);
                                                                }
                                                            }}
                                                        />
                                                    </FormControl>
                                                    {touched.summaryLink && errors.summaryLink ? (
                                                        <div className="error">{errors.summaryLink}</div>
                                                    ) : null}
                                                </>
                                            )}


                                        </Grid>
                                    </Card>
                                </Grid>
                            </Grid>
                           

                            {user.roles_id <= 3 ?
                                <>
                                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{ display: "flex", justifyContent: "center" }} mt={2}>
                                        <Button sx={{ minWidth: 350, maxWidth: 300 }} className="CustomButton" onClick={handleSubmit}>
                                            SAVE INFORMATION
                                        </Button>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12} mt={2} sx={{ display: "flex", justifyContent: "center", alignItems: "center", }}>
                                        <p style={{ fontSize: "16px", textAlign: "center", display: "flex", alignItems: "center", margin: 0, }}><span><i><img src={require('../../assets/images/snapVector.png')} alt="Snap Vector" style={{ width: "25px", verticalAlign: "middle", }} /> Ensure All Required Fields Are Completed And Remember To Save.</i> </span></p>
                                    </Grid>
                                </>
                                : null}
                        
                    </div>
                )}
            </Formik>
            {/* formik end */}
        </Card>

        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            {/* Close button */}
            <IconButton
                aria-label="close"
                onClick={handleClose}
                style={{ position: "absolute", right: 8, top: 8 }}
            >
                <CloseIcon sx={{ color: "white" }} />
            </IconButton>

            {/* Dialog Content with Video */}
            <DialogContent style={{ padding: 0 }}>
                <iframe
                    width="100%"
                    height="400px"
                    src="https://www.youtube.com/embed/QOyOfg9D288?si=-N4y8jsigCi91MFc"
                    title="Video Player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ border: "none" }}
                ></iframe>
            </DialogContent>
        </Dialog>

        <Dialog
            open={open2}
            onClose={handleClose2}
            maxWidth="md"
            fullWidth
        >
            {/* Close button */}
            <IconButton
                aria-label="close"
                onClick={handleClose2}
                style={{ position: "absolute", right: 8, top: 8 }}
            >
                <CloseIcon sx={{ color: "white" }} />
            </IconButton>

            {/* Dialog Content with Video */}
            <DialogContent style={{ padding: 0 }}>
                <iframe
                    width="100%"
                    height="400px"
                    src="https://www.youtube.com/embed/5SiyOJLt1y0?si=1fQs16b1uKqrHynp"
                    title="Video Player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ border: "none" }}
                ></iframe>
            </DialogContent>
        </Dialog>
    </>
);
}

export default CompanyDetails;